export default "__VITE_ASSET__BOYGx74F__"